import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Home from "./layout/Home/Main";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Archive from "./layout/Archive/Archive";
import Footer from "./components/Footer/Footer";
// import Preloader from './components/Preloader/Preloader'

function App() {


  return (
    <BrowserRouter>

      <Navbar />
      {/* <Preloader /> */}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/archive" element={<Archive />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;
